import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  ActionRow,
  Button,
  Icon,
  Stack,
} from '@openedx/paragon';
import { Locked } from '@openedx/paragon/icons';

import messages from './messages';

const UpgradeBanner = ({ upgradeUrl }) => {
  const intl = useIntl();

  return (
    <ActionRow className="my-3 p-4 bg-primary rounded">
      <Stack direction="horizontal" gap={3} className="text-white align-items-start">
        <Icon src={Locked} />
        <Stack>
          <div className="h4 text-white">
            {intl.formatMessage(messages.upgradeBannerHeader)}
          </div>
          <div className="small">
            {intl.formatMessage(messages.upgradeBannerMessage)}
          </div>
        </Stack>
      </Stack>
      <ActionRow.Spacer />
      <Button
        size="sm"
        variant="inverse-primary"
        as="a"
        href={upgradeUrl}
      >
        {intl.formatMessage(messages.upgradeBannerButtonLabel)}
      </Button>
    </ActionRow>
  );
};

UpgradeBanner.propTypes = {
  upgradeUrl: PropTypes.string.isRequired,
};

export default UpgradeBanner;
